export default {
  name: "HeForShe Kinetic Typography",
  tags: ["typography", "motion graphics"],
  description: "Impactful motion graphics video project",
  hash: "he-for-she",
  thumbnail: {
    type: "image",
    src: "/img/thumb/he-for-she.webp",
    alt: "Black and white text on a pink background reading 'If we stop defining eachother by what we are not and start defining ourselves by who we are we can all be freer'. Icons representing aspects of identities and professions surround the text."
  },
  content: [{
    type: "md",
    heading: "The Project",
    text: `The HeForShe campaign is a powerful statement on the current status of feminism, male allyship, and the impacts of gender inequality on all genders.  HeForShe is part of the UN Women initiative, and was announced in a speech that Emma Watson gave to the UN. I created this video as a school project, for my Visual Rhetoric course.
##### Problem — Create an engaging video presentation of the speech
My goal with this project was to complement the speech—to give it visual interest and present the words in a way that illustrates their meaning without detracting from the audio. I also wanted to keep it consistent with HeForShe's campaign, as if it were commissioned by them.
##### Solution — Kinetic Typography
I created a video using kinetic typography to portray the words of the speech. I used the official colour scheme of HeForShe, and used their logo. I created my own animations for the logo, and carefully chose the layout and timing of words, the use of symbols, and the contrasts of colours, sizes, fonts, and weights of type. They are all intended to reinforce the emphasis and meaning of the speech.
##### Challenges
- **Applause** — I found that the applause in the background was difficult to complement with kinetic type. I decided to edit out most of the applause, which created a more consistent pace to the speech as well.

- **Animation Timing** — The timing of the animation had to be closely matched to how Ms. Watson paced and pronounced the words. In some cases I matched them frame by frame using the audio waveform as a guide.

- **Icons** — I didn't feel confident in my icon design skills to create the variety I needed for the splash of careers. I decided to use icons from the Noun Project, which saved me a lot of time.`,
    visual: {
      type: "vimeo",
      src: "https://player.vimeo.com/video/154866435",
      width: 1280,
      height: 720,
      title: "HeForShe kinetic typography",
      // fallBack: "/img/ducks.webp"
    }
  }]
}
